// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"c9cd9f97888db129","797":"eb9713a488aac5e0"}[chunkId] + ".css";
};